import { DiagnosticsMeasureResultsTableWrapper } from "../../../widgets/diagnostics/diagnosticsMeasureResultsSection/DiagnosticsMeasureResultsTableWrapper";
import { useDispatch } from "react-redux";
import { setPeriodRoadMeasureResults, setType } from "../../../stateManagement/reducers/diagnostics/DiagnosticsRoadMeasureResultsSlice";
import { useAppSelector } from "../../../stateManagement/hooks/redux";
import { Slider } from "@mui/material";
import { DiagnosticsYearFilters } from "../../../widgets/diagnosticsYearFilters";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getItemWebStorage, setItemWebStorage } from "../../../features/webStorageSaver";
import { classNames } from "primereact/utils";
import ContentHeader from "../../../widgets/contentHeader/ContentHeader";

let reverseIndex: any = {
    4: 0,
    3: 1,
    2: 2,
    1: 3,
    0: 4
}

function formMarksForRange(currentYear: number) {
    let marks = [];
    for (let i = 4; i >= 0; i--) {
        marks.push({
            value: currentYear - i,
            label: `${currentYear - reverseIndex[i]}`
        })
    }
    return marks
}

function getInvertedValues(currentYear: number) {
    let obj: any = {}
    for (let i = 4; i >= 0; i--) {
        const field = currentYear - i;
        const value = currentYear - reverseIndex[i]
        obj[field] = value
    }
    return obj
}

// Компонент - страница состава диагностики в разделе диагностики.
export function DiagnosticsMeasureResultsTablePage() {
    const dispatch = useDispatch()
    const navigate = useNavigate();
    const chosenYear = useAppSelector(state => state.diagnosticsRoadMeasureResults.period)
    const type = useAppSelector(state => state.diagnosticsRoadMeasureResults.type)
    const sideBarState = useAppSelector(state => state.sidebar.sidebarIsShown)
    const measureType = useAppSelector(state => state.diagnostics.currentRoadMeasureResultsType)
    const measureUnit = useAppSelector(state => state.diagnostics.currentMeasureUnit)

    const [isSmallWindow, setIsSmallWindow] = useState(false);
    const [name, setName] = useState<any>()
    const currentYear = new Date().getFullYear();
    const values: any = getInvertedValues(currentYear)
    const marks = formMarksForRange(currentYear)

    useEffect(() => {
        if (measureType && measureUnit) {
            setName(`Таблица «Результаты измерений» - ${measureType} (${measureUnit})`)
        } else if (measureType && !measureUnit) {
            setName(`Таблица «Результаты измерений» - ${measureType}`)
        } else {
            setName("Таблица «Результаты измерений»")
        }
    }, [measureType, measureUnit])

    useEffect(() => {
        const contentHeaderWidth: any = document.querySelector('.content-header-div')?.getBoundingClientRect().width;
        setIsSmallWindow(contentHeaderWidth < 1080);
    }, [sideBarState, navigate])

    useEffect(() => {
        const hasSeenYearForMobile = getItemWebStorage('diagnosticsYearFilters')?.roadMeasureResultsSeen
        const contentHeaderWidth: any = document.querySelector('.content-header-div')?.getBoundingClientRect().width;
        if (!hasSeenYearForMobile && contentHeaderWidth < 1080) {
            navigate('/app/diagnostics/diagnosticsMeasureResults/filters')
        }
    }, [])

    let chosenYearForSlider = values[`${new Date().getFullYear()}`]
    if (chosenYear.includes('-')) {
        chosenYearForSlider = values[chosenYear.split('-')[0]]
    }

    function valuetext(value: number) {
        const newValue = values[value]
        if (newValue == currentYear) {
            return `${currentYear}`
        } else {
            return `${newValue}-${currentYear}`
        }
    }

    function handleChange(event: Event, newValue: any, activeThumb: number) {
        if (newValue === currentYear - 4) {
            dispatch(setPeriodRoadMeasureResults(`${currentYear}`))
            setItemWebStorage('diagnosticsYearFilters', { ...getItemWebStorage('diagnosticsYearFilters'), roadMeasureResults: `${currentYear}` })
        } else {
            dispatch(setPeriodRoadMeasureResults(`${values[newValue]}-${currentYear}`))
            setItemWebStorage('diagnosticsYearFilters', { ...getItemWebStorage('diagnosticsYearFilters'), roadMeasureResults: `${values[newValue]}-${currentYear}` })
        }
        setItemWebStorage('diagnosticsYearFilters', { ...getItemWebStorage('diagnosticsYearFilters'), roadMeasureResultsType: 'segment' })
        dispatch(setType('segment'))
    }

    let segmentYearFilterDivClassName = classNames({
        "segment-year-filter-div-active": type === "segment",
        "segment-year-filter-div-disabled": type !== "segment"
    })

    return (
        <>
            <ContentHeader title={name} type="table" option="diagnosticsMeasureResults"/>
            {!isSmallWindow && <div className="year-filter-div">
                <div className="ms-2 single-year-label-div">
                    <span style={type == 'single' ? { color: 'white' } : { color: '#add7ee' }}>
                        За один год
                    </span>
                </div>
                <DiagnosticsYearFilters type="header" filterType="RoadMeasureResults" />
                <div className="segment-year-label-div">
                    <span style={type == 'segment' ? { color: 'white' } : { color: '#add7ee' }}>
                        За несколько лет<br />самые актуальные
                    </span>
                </div>
                <div className={segmentYearFilterDivClassName} >
                    <div className="segment-year-filter">
                        <Slider
                            style={(type !== 'segment') ? { color: '#bdbdbd' } : {}}
                            defaultValue={chosenYearForSlider}
                            valueLabelFormat={valuetext}
                            onChange={handleChange}
                            valueLabelDisplay="auto"
                            step={1}
                            marks={marks}
                            min={currentYear - 4}
                            max={currentYear}
                            size="small"
                        />
                    </div>
                </div>
            </div>}
            <div className="table-wrap-with-list">
                <DiagnosticsMeasureResultsTableWrapper />
            </div>
        </>
    );
}